    <nav class="drive-tree" [attr.aria-label]="view.translate('drive.tree_aria_label')" role="tree" (click)="view.closeContextMenu()">
      <div class="tree-root" role="treeitem" aria-expanded="true" (contextmenu)="view.onRootContextMenu($event)">
        <mat-icon aria-hidden="true">folder</mat-icon>
        <button class="tree-link" type="button" (click)="view.rootFolder && view.navigateTo(view.rootFolder.id)">{{ view.displayName(view.rootFolder?.name) || view.translate('drive.my_drive') }}</button>
      </div>

      <ng-template #renderNode let-node>
        <li role="treeitem" [attr.aria-expanded]="view.isExpanded(node.id)" (contextmenu)="view.onTreeContextMenu($event, node)">
          <div class="tree-row" [class.active]="node.id===view.currentFolderId"
               [class.selected]="view.selectedIds.has(node.id)"
               [class.file-node]="node.type !== 'folder'"
               [class.drop-candidate]="view.isFolderDropCandidate(node)"
               [class.drop-hover]="view.dragHoverFolderId === node.id"
               cdkDropList [id]="view.dropListId('tree', node)" [cdkDropListConnectedTo]="view.sourceDropListIds" (cdkDropListDropped)="view.onDropOnFolder($event, node)"
               (cdkDragEntered)="view.onFolderDragEntered(node)" (cdkDragExited)="view.onFolderDragExited(node)"
               [cdkDropListDisabled]="node.type !== 'folder' || view.isVirtualFolderId(node.id)"
               (dragover)="view.onNativeFolderDragOver($event, node)" (dragleave)="view.onNativeFolderDragLeave(node)" (drop)="view.onNativeDropOnFolder($event, node)"
               (dblclick)="view.onTreeItemDoubleClick(node, $event)">
            <button class="tree-caret" type="button" [class.invisible]="!view.hasChildFolders(node.id)" (click)="view.hasChildFolders(node.id) && view.toggleExpand(node.id, $event)" [attr.aria-hidden]="!view.hasChildFolders(node.id)" [disabled]="!view.hasChildFolders(node.id)" aria-label="toggle">
              <mat-icon aria-hidden="true">{{ view.isExpanded(node.id) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
            <mat-icon class="doc-type-icon" [ngClass]="view.getItemIconClass(node)" aria-hidden="true">{{ view.getItemIcon(node) }}</mat-icon>
            <button class="tree-link" type="button" (click)="view.onTreeItemClick(node, $event)">{{ view.displayName(node.name) }}</button>
          </div>
          <ul class="tree-list" *ngIf="view.isExpanded(node.id) && view.childFolders(node.id).length">
            <ng-container *ngFor="let c of view.childFolders(node.id); trackBy: view.trackById">
              <ng-container *ngTemplateOutlet="renderNode; context: {$implicit: c}"></ng-container>
            </ng-container>
          </ul>
        </li>
      </ng-template>

      <ul class="tree-list">
        <ng-container *ngFor="let f of view.childFolders(view.rootFolder?.id || null); trackBy: view.trackById">
          <ng-container *ngTemplateOutlet="renderNode; context: {$implicit: f}"></ng-container>
        </ng-container>
      </ul>
    </nav>
